export enum StoreTransactionType {
  REFUND = "REFUND",
  COMPLETED = "COMPLETED",
  CANCELED = "CANCELED",
  SETTLEMENT = "SETTLEMENT",
  ADMINWITHDRAW = "ADMIN_WITHDRAW",
}
